function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import plugin from 'tailwindcss/plugin.js';
import typographyPlugin from '@tailwindcss/typography';
import aspectRatioPlugin from '@tailwindcss/aspect-ratio';
import colorVariablesPlugin from '@mertasan/tailwindcss-variables';
import gridAreasPlugin from '@savvywombat/tailwindcss-grid-areas';
import { colors, colorValues } from './colors.js';
import { maxWidth } from './maxWidth.js';
import { fontFamily } from './fontFamily.js';
import { fontSize } from './fontSize.js';
import { lineHeight } from './lineHeight.js';
import { letterSpacing } from './letterSpacing.js';
import { spacing } from './spacing.js';
import { screens } from './screens.js';
import { borderRadius } from './borderRadius.js';
export var config = {
    content: [
        '**/*.tsx'
    ],
    corePlugins: {
        container: false
    },
    theme: {
        extend: {
            spacing: spacing,
            maxWidth: maxWidth,
            screens: screens,
            minWidth: _object_spread({}, spacing),
            minHeight: _object_spread({}, spacing)
        },
        colors: colors,
        fontFamily: fontFamily,
        fontSize: fontSize,
        lineHeight: lineHeight,
        letterSpacing: letterSpacing,
        borderRadius: borderRadius,
        typography: {
            DEFAULT: {
                css: {
                    a: {
                        color: 'var(--colors-link-fg-base)',
                        'font-weight': '600',
                        'text-decoration': 'underline'
                    },
                    'ul:not([class])': {
                        'list-style': 'disc',
                        'padding-left': spacing['5']
                    },
                    'ul:not([class]) li:not([class])': {
                        margin: "".concat(spacing['3'], " 0")
                    },
                    'p, ul, img': {
                        '&:not(:first-child):not([class])': {
                            'margin-top': spacing['5']
                        },
                        '&:not(:last-child):not([class])': {
                            'bottom-top': spacing['5']
                        }
                    },
                    '.p': {
                        '&:not(:first-child)': {
                            'margin-top': spacing['5']
                        },
                        '&:not(:last-child)': {
                            'bottom-top': spacing['5']
                        }
                    },
                    'h1, h2, h3, h4, h5': {
                        '@apply font-heading': {},
                        '@apply font-semibold': {},
                        '&:not(:first-child):not([class])': {
                            'margin-top': spacing['6']
                        },
                        '&:not([class]) + :not([class]):is(h1, h2, h3, h4, h5)': {
                            'margin-top': '0'
                        },
                        '&:not(:last-child):not([class])': {
                            'margin-bottom': spacing['4']
                        }
                    },
                    'h1, h2': {
                        '@apply leading-snug': {},
                        '@apply text-heading-h2-base': {},
                        '@apply md:text-heading-h2-desktop': {}
                    },
                    h3: {
                        '@apply leading-snug': {},
                        '@apply text-heading-h3-base': {},
                        '@apply md:text-heading-h3-desktop': {}
                    },
                    h4: {
                        '@apply leading-snug': {},
                        '@apply text-heading-h4-base': {}
                    },
                    strong: {
                        'font-weight': '600'
                    }
                }
            },
            neutral: {
                css: {
                    a: {
                        color: 'inherit',
                        'font-weight': '400'
                    },
                    strong: {
                        'font-weight': '600'
                    }
                }
            }
        },
        variables: {
            DEFAULT: {
                colors: colorValues
            }
        }
    },
    plugins: [
        gridAreasPlugin,
        typographyPlugin,
        aspectRatioPlugin,
        colorVariablesPlugin({
            colorVariables: true
        }),
        plugin(function(param) {
            var addUtilities = param.addUtilities, matchUtilities = param.matchUtilities;
            addUtilities({
                '.safari-fix-transform': {
                    '-webkit-transform': 'translate3d(0px, 0px, 0px)'
                }
            });
            matchUtilities({
                count: function count(value) {
                    return {
                        'counter-reset': value
                    };
                },
                'count-inc': function(value) {
                    return {
                        'counter-increment': value
                    };
                }
            });
        })
    ]
};

//# sourceMappingURL=config.js.map